import { emptyPromise } from 'shared/utilities';
import actions from './actions';
import mutations from './mutations';
import getters from './getters';

export const makeInitialState = () => ({
  data: {},
  loginErr: null,
  loginErrMessage: '',
  registrationError: '',
  status: 'Unfetched',
  loginComplete: emptyPromise(),
});

export default {
  namespaced: true,
  state: makeInitialState(),
  actions,
  mutations,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/users/index.js